import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { deleteJob } from '../../../../../services/jobsService';
import { useJobContext } from '../../../../../context/JobContext';
import useProfileLinks from '../../../../../hooks/useProfileLinks';
import { getImage } from '../../../../../utils/cloudinarySizing';

// User Job Box
const JobBox = ({
    jobs,
    setJobs,
    activeDropdown,
    toggleDropdown,
    activeJobMenuId,
    toggleJobOptionsMenu,
    // toggleVisibility, // Uncomment and pass if you want to handle visibility toggling
}) => {
    const navigate = useNavigate();
    const [loadedImages, setLoadedImages] = useState({});


    const { setShowAddJob, openEditJob, editedJob, setEditedJob } = useJobContext();

    const handleJobClick = (id) => {
        navigate(`/service-requests/${id}`);
    };

    const formatBudget = (job) => {
        const budget = parseFloat(job.budget);
        if (isNaN(budget)) {
            return "TBD";  // Return "N/A" if budget is null, undefined, or not a valid number
        }
        return budget % 1 === 0 ? budget.toFixed(0) : budget.toFixed(2);
    };


    const handleDeleteJob = async (jobId) => {
        try {
            await deleteJob(jobId); // API call to soft delete the job
            setJobs(prevJobs => prevJobs.filter(job => job.id !== jobId)); // Update local state
            toast.success("Job deleted successfully.");
            // Optionally: showToast("Job deleted", "success");
        } catch (error) {
            toast.error("Failed to delete the job.");
            // Optionally: showToast("Failed to delete job", "error");
        }
    };

    const editJob = (job) => {
        toggleJobOptionsMenu(job.id);
        openEditJob(job);
    }
    

    useEffect(() => {
        if (editedJob) {
            setJobs(prevJobs =>
                prevJobs.map(job =>
                    job.id === editedJob.id ? editedJob : job
                )
            );
            setEditedJob(null); // Optional: clear it out
        }
    }, [editedJob]);

    return (
        <div className="job-box">

            <h3>
                <i className="fa-solid fa-wrench"></i> Service Requests
            </h3>

            <div className="header-row">
                <button className="add-request-button" onClick={() => setShowAddJob(true)}>
                    <i className="fa-solid fa-plus"></i> Request Service
                </button>
            </div>


            {jobs.length > 0 && (
                <p className="media-results-count">
                    {jobs.length} service request{jobs.length !== 1 && 's'}
                </p>
            )}

            <div className="job-list">
                {jobs.length === 0 ? (
                    <p>No service requests posted yet.</p>
                ) : (
                    jobs.map((job, index, arr) => (
                        <div key={job.id}>
                            <div className="job-item" onClick={() => handleJobClick(job.id)}>
                                {job.images?.length > 0 ? (
    <>
        {!loadedImages[job.id] && (
            <div className="service-request-placeholder">
                <span>No Image</span>
            </div>
        )}

        <img
            src={getImage(job.images[0].image, "srv_sm")}
            alt="Job thumbnail"
            className="job-thumbnail"
            style={{
                display: loadedImages[job.id] ? "block" : "none"
            }}
            onLoad={() => {
                setLoadedImages(prev => ({
                    ...prev,
                    [job.id]: true
                }));
            }}
            onError={(e) => {
                e.currentTarget.style.display = "none";

                setLoadedImages(prev => ({
                    ...prev,
                    [job.id]: false
                }));
            }}
        />
    </>
) : (
    <div className="service-request-placeholder">
        <span>No Image</span>
    </div>
)}
                                <div className="job-info">
                                    <strong>{job.title}</strong>
                                    <p className="job-detail">{job.description}</p>
                                    <p className="job-meta">
                                        <strong>Pay:</strong> <i className="fas fa-dollar-sign money-icon"></i> {formatBudget(job)} / {job.budget_type}
                                        <span className="separator">|</span>
                                        <i className="fas fa-location-dot location-icon"></i> <strong>Location:</strong> {job.location}
                                    </p>
                                </div>
                                <div className="job-actions">
                                    <button
                                        className="ellipsis-button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleJobOptionsMenu(job.id);
                                        }}
                                    >
                                        <i className="fas fa-ellipsis-v"></i>
                                    </button>

                                    {activeJobMenuId === job.id && (
                                        <div className="job-dropdown-menu">
                                            <button className="job-dropdown-item"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    editJob(job);
                                                }}>
                                                <i className="fas fa-pencil-alt"></i> Edit
                                            </button>
                                            <button
                                                className="job-dropdown-item"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDeleteJob(job.id);
                                                }}
                                            >
                                                <i className="fas fa-trash job-delete"></i> Delete
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {index < arr.length - 1 && <hr className="menu-separator" />}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default JobBox;
